import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryInterviewAttributes } from './generated/DiscoveryInterviewAttributes';
import { model } from '../modelBuilder';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

interface DiscoveryInterview extends DiscoveryInterviewAttributes {}

@model
class DiscoveryInterview extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryInterview' = 'DiscoveryInterview';
  get typename(): 'DiscoveryInterview' {
    return 'DiscoveryInterview';
  }

  static internalTypename: 'Discovery::Interview' = 'Discovery::Interview';
  get internalTypename(): 'Discovery::Interview' {
    return 'Discovery::Interview';
  }

  static inputType = 'InterviewAttributes!';

  static filterType = 'InterviewFilters!';
  static filters = {
    id: '[ID!]',
    discoveryStudyId: '[ID!]',
    projectId: '[ID!]',
    discoveryInterviewTypeId: '[ID!]',
    mode: 'DiscoveryInterviewMode',
    startTime: 'ISO8601DateTime',
    endTime: 'ISO8601DateTime',
    status: 'DiscoveryInterviewStatus',
  };

  static fields = {
    aiSummary: attr({ writable: true, readable: true }),
    anonymized: attr({ writable: true, readable: true }),
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    disableUploadSteps: attr({ writable: true, readable: true }),
    discoveryIdeaUserInterviewsCount: attr({ readable: true }),
    discoveryInterviewTypeId: attr({ writable: true, readable: false }),
    discoveryInterviewUsersCount: attr({ readable: true }),
    discoveryScriptPromptUsesCount: attr({ readable: true }),
    discoveryStudyId: attr({ readable: true }),
    duration: attr({ readable: true }),
    endTime: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    interviewTypeId: attr({ readable: true }),
    mode: attr({ writable: true, readable: true }),
    name: attr({ writable: true, readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    recordingUrl: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    sentiments: attr({ writable: true, readable: true, json: true }),
    speakerNameMapping: attr({ readable: true, json: true }),
    startTime: attr({ writable: true, readable: true }),
    status: attr({ writable: true, readable: true }),
    thumbnailUrl: attr({ readable: true }),
    transcriptionInProgress: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    discoveryStudy: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryStudy',
    }),
    interviewType: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryInterviewType',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    comments: attr.hasMany({ readable: true }),
    discoveryIdeaUserInterviews: attr.hasMany({ readable: true }),
    discoveryInterviewUsers: attr.hasMany({ readable: true }),
    discoveryScriptPromptUses: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  startTimeLocal(timezone: string): dayjs.Dayjs {
    return dayjs(this.startTime).tz(timezone);
  }

  endTimeLocal(timezone: string): dayjs.Dayjs {
    return dayjs(this.endTime).tz(timezone);
  }
}

export default DiscoveryInterview;
